import AuditDetailsColumn from './DetailsColumn';
export const DetailsColumn = AuditDetailsColumn;